// extracted by mini-css-extract-plugin
module.exports = {"categoryProducts":"CategoryProducts-module--categoryProducts--1BvFY","header":"CategoryProducts-module--header--2vn1O","products":"CategoryProducts-module--products--2LjFm"};